import HelpSharpIcon from '@mui/icons-material/HelpSharp';
import Grid from '@mui/material/Grid';
import classNames from 'classnames';
import { Fragment, useRef, useState } from 'react';
import CritialPeriodModal from '/@/components/crop-monitoring/progress-bar/criticalperiodModal';
import colors from '/@/components/theme-provider/colors';
import { _ } from '/@/locale';
import { formatDate, formatDateCMProgressBar } from '/@/utils';
import Title from '/@/v3/components/title';
import styles from '../../styles.module.css';

const ProgressBarCard = ({ date, step, stateText, color, expectedFloweringDate, showAlert }) => {
    const [criticalPediodModalOpened, setCriticalPediodModalOpened] = useState(false);
    const ref = useRef(null);

    let formattedEFD;
    if (step.state === 'R' && showAlert) {
        formattedEFD = formatDateCMProgressBar(formatDate(expectedFloweringDate));
    }

    return (
        <div className={classNames(styles.balloon, styles[`balloon-${color}`])} ref={ref}>
            <Grid
                container
                direction='column'
                justifyContent='flex-start'
                alignItems='space-between'
                sx={{ bgcolor: color }}
            >
                {!formattedEFD ? (
                    <Fragment>
                        {date !== '' && (
                            <Grid item sx={{ m: 0.5, ml: 1 }}>
                                <Title bold size='sm' color='white'>
                                    {date}
                                </Title>
                            </Grid>
                        )}
                        <Grid item sx={{ m: 0.5, ml: 1 }}>
                            <Title bold size='sm' color='white'>
                                {`${_(step.displayName)} - ` + stateText}
                            </Title>
                        </Grid>
                    </Fragment>
                ) : (
                    // Critic Period variation
                    <Fragment>
                        <Grid item sx={{ m: 0.5, ml: 1 }}>
                            <Title bold size='sm' color='white'>
                                {`${_(step.displayName)} - ` + stateText}
                            </Title>
                        </Grid>
                        <Grid
                            item
                            sx={{
                                background: '#FCEAEA',
                                borderBottomRightRadius: '6px',
                                borderBottomLeftRadius: '6px',

                                mb: 0.4,
                                pb: 0.1,

                                mt: 0,
                                py: 0.25,

                                mx: 0.5,
                                px: 0.5,

                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Title bold size='sm' color='red'>
                                {formattedEFD} - {_('Estado crítico +/- 15 días')}{' '}
                            </Title>
                            <HelpSharpIcon
                                sx={{ color: colors.dark.default, mx: 1, ml: 'auto', cursor: 'pointer' }}
                                onClick={() => setCriticalPediodModalOpened(true)}
                            />
                        </Grid>
                    </Fragment>
                )}
            </Grid>
            <CritialPeriodModal
                expectedFloweringDate={expectedFloweringDate}
                open={criticalPediodModalOpened}
                setOpen={setCriticalPediodModalOpened}
            />
        </div>
    );
};

export default ProgressBarCard;
